import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import cls from './LanguageSwitcher.module.css';

export const LanguageSwitcher = () => {
  // Вызываем t, чтобы компонент "слушал" изменения
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const languages = ['kk', 'ru', 'en'];

  // Текущий код (без регионов типа -RU)
  const currentLangCode = i18n.resolvedLanguage || i18n.language || 'ru';
  const displayCode = currentLangCode.split('-')[0];

  console.log('currentLangCode' , currentLangCode)

  const toggleDropdown = () => setIsOpen(!isOpen);

  const selectLanguage = (code: string) => {
    i18n.changeLanguage(code);
    setIsOpen(false);
  };

  return (
    <div className={cls.wrapper}>
      {/* Кнопка: используем t(), чтобы заставить React перерисовать лейбл */}
      <button className={cls.mainBtn} onClick={toggleDropdown}>
        <span className={cls.label}>
          {t(`languages.${displayCode}`).toUpperCase()}
        </span>
        <motion.span 
          animate={{ rotate: isOpen ? 180 : 0 }}
          className={cls.arrow}
        >
          ▾
        </motion.span>
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className={cls.dropdown}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
          >
            {languages
              .filter(lang => !currentLangCode.startsWith(lang))
              .map((lang) => (
                <button
                  key={lang}
                  className={cls.langOption}
                  onClick={() => selectLanguage(lang)}
                >
                  {/* Здесь тоже используем t() */}
                  {t(`languages.${lang}`).toUpperCase()}
                </button>
              ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};